export default function MoneyRenderer(money, decimalPrecision= 2) {
    return parseFloat(money).toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: decimalPrecision
    });
}